import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ServiceOrderShellComponent } from './service-order-shell/service-order-shell.component'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { ComponentsModule } from 'src/app/components/components.module'
import { ServiceOrderTableComponent } from './service-order-table/service-order-table.component'
import { ServiceOrderDetailsModalComponent } from './service-order-details-modal/service-order-details-modal.component'
import { NgxPaginationModule } from 'ngx-pagination'
import { FormatQtyPipe } from './format-qty.pipe'
import { OrderFilterComponent } from './order-filter/order-filter.component'
import { CalendarModule } from 'primeng/calendar'
import { TableModule } from 'primeng/table'

@NgModule({
  declarations: [
    ServiceOrderShellComponent,
    ServiceOrderTableComponent,
    ServiceOrderDetailsModalComponent,
    FormatQtyPipe,
    OrderFilterComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    ComponentsModule,
    NgxPaginationModule,
    CalendarModule,
    TableModule,
  ],
})
export class ServiceOrdersModule {}
